import Vue from "vue";
import VueRouter from "vue-router";
import Logoff from "../views/logoff.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Logoff",
    component: Logoff,
  },
  {
    path: "/offdetail",
    name: "offDetail",
    component: () =>
      import(/* webpackChunkName: "offDetail" */ "../views/offDetail.vue"),
  },
  {
    path: "/protocol",
    name: "Protocol",
    component: () =>
      import(/* webpackChunkName: "Protocol" */ "../views/protocol.vue"),
  },
   {
    path: "/protocolios",
    name: "ProtocolIos",
    component: () =>
      import(/* webpackChunkName: "ProtoclIos" */ "../views/protocolIos.vue"),
  },
  { //阅读注销须知
    path: "/readlogoff",
    name: "readLogoff",
    component: () =>
      import(/* webpackChunkName: "readLogoff" */ "../views/readOff.vue"),
  },
  {
    path: "/logofffinish",
    name: "LogoffFinish",
    component: () =>
      import(/* webpackChunkName: "LogoffFinish" */ "../views/logoffFinish.vue"),
  },
    {
    path: "/logofffinishios",
    name: "LogoffFinishIos",
    component: () =>
      import(/* webpackChunkName: "LogoffFinishIos" */ "../views/logoffFinishIos.vue"),
  },
  {
    path: "/usermsg",
    name: "UserMsg",
    component: () =>
      import(/* webpackChunkName: "UserMsg" */ "../views/userMsg.vue"),
  },
  {
    path: "/perreminder",
    name: "perReminder",
    component: () =>
      import(/* webpackChunkName: "perReminder" */ "../views/reminder/perReminder.vue"),
  },
  {
    path: "/perreminderios",
    name: "perReminderIos",
    component: () =>
      import(/* webpackChunkName: "perReminder" */ "../views/reminder/perReminderIos.vue"),
  },
  {
    path: "/agelimit",
    name: "ageLimit",
    component: () =>
      import(/* webpackChunkName: "ageLimit" */ "../views/ageLimit/ageRem.vue"),
  }, 
    {
    path: "/agelimitios",
    name: "ageLimitIos",
    component: () =>
      import(/* webpackChunkName: "ageLimit" */ "../views/ageLimit/ageRemIos.vue"),
  }, 
  {
    path: "/privacypolicy",
    name: "privacyPolicy",
    component: () =>
      import(/* webpackChunkName: "privacyPolicy" */ "../views/privacyPolicy/index.vue"),
  },
    {
    path: "/privacypolicyios",
    name: "privacyPolicyIos",
    component: () =>
      import(/* webpackChunkName: "privacyPolicyIos" */ "../views/privacyPolicy/indexIos.vue"),
  },
  {
    path: "/servercontract",
    name: "servercontract",
    component: () =>
      import(/* webpackChunkName: "serverContract" */ "../views/serverContract/index.vue"),
  }, 
  {
    path: "/servercontractios",
    name: "servercontractIos",
    component: () =>
      import(/* webpackChunkName: "serverContract" */ "../views/serverContract/indexIos.vue"),
  }, 

];

const router = new VueRouter({
  routes,
});

export default router;
